import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { FRAUD_OPERATIONS_ROUTE_PATHS } from './config';

export const FRAUD_OPERATIONS_ROUTES: TApplicationRoute[] = [
  {
    id: 'fraud-operations',
    path: FRAUD_OPERATIONS_ROUTE_PATHS.fraudOperations,
    component: lazy(() => import('./pages/fraud-operations-page')),
    layout: 'default',
    permissions: { scopes: ['fraud-operations'] },
    menu: {
      title: 'pages.fraud.fraudOperations.title',
    },
  },
];
